import { IonButton, IonHeader, IonModal, IonSpinner, IonToolbar } from "@ionic/react";
import { useContext, useState } from "react";
import { APIService } from "../network/APIService";
import AppContext from "../providers/AppContext";
import { User } from "../utils/Interfaces";

const DeleteUserModal = ({
  user,
  isOpen,
  handleModalDismiss,
}: {
  user: User | undefined;
  isOpen: boolean;
  handleModalDismiss: (deletedUser: boolean) => void;
}) => {
  const appContext = useContext(AppContext);
  const [deletingUser, setDeletingUser] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleDeleteUser = async () => {
    setErrorMessage("");
    setDeletingUser(true);
    const deletedUserSuccessfully = await APIService.deleteUser(user?.email!, appContext.jwt);
    setDeletingUser(false);

    if (deletedUserSuccessfully) {
      handleModalDismiss(true);
    } else {
      // show error message
      setErrorMessage("Failed to delete the user. Please restart your browswer and try again.");
    }
  };

  return (
    <IonModal backdropDismiss={false} isOpen={isOpen} className="deleteModal">
      <IonHeader>
        <IonToolbar>
          <div className="modalToolbarContent">
            <div className="modalToolbarSides" />
            <p>Delete User</p>
            {deletingUser ? (
              <div className="modalToolbarSides">
                <IonSpinner name="bubbles" />
              </div>
            ) : (
              <div className="modalToolbarSides" />
            )}
          </div>
        </IonToolbar>
      </IonHeader>
      <div className="modalMainContent">
        <p className="modalConfirmationText">
          Are you sure you want to delete "<span>{user?.displayName}</span>"?
        </p>
        {errorMessage && <p className="modalErrMessage">{errorMessage}</p>}
      </div>
      <div className="modalFooterButtonsContainer">
        <IonButton
          disabled={deletingUser}
          className="cancelBtn"
          onClick={() => {
            setErrorMessage("");
            handleModalDismiss(false);
          }}
        >
          Cancel
        </IonButton>
        <IonButton disabled={deletingUser} className="deletePillBtn" onClick={handleDeleteUser}>
          Delete User
        </IonButton>
      </div>
    </IonModal>
  );
};

export default DeleteUserModal;
